<template functional>
  <div v-if="props.row.status_request === 'Aprobado'">
    <translate-text keyTranslate="shopping.approved" />
  </div>
  <div v-else-if="props.row.status_request === 'Pendiente'">
    <translate-text keyTranslate="shopping.pending" />
  </div>
  <div v-else-if="props.row.status_request === 'Rechazado'">
    <translate-text keyTranslate="shopping.rejected" />
  </div>
</template>
<script>
export default {
  name: 'StatusRequestInfo',
};
</script>
